<template>
	<div class="newpage">
		<div class="printTest-box">
			<div id="printTest">
				<div style="display: flex;flex-direction: column;align-items: center;">
				    <div >
						<loading class="loading_style" :tip="tip" v-if="!th_printdata.length"></loading>
						<div ref="menuItem" v-else>
							<div    :style="item.genre === 'order' ? sliderStyle : sliderStyleCopy"     v-for="(item,index) in arr" :key="index">
								<div>
									<div class="loading-box" v-if="!item.orderPdf.image">
										<div class="desc_failed">{{$t('other.a496')}}</div>
									</div>
									<div   style="width: 100%;overflow: hidden;">
										<div id="orderHtml" v-html="ivn">
											<!-- <img  style="width: 100%;"  :src='item.orderPdf.image' /> -->
											
										</div>
									</div>
								</div>
							</div>
							
						</div>
					</div>
				</div>
				  
			</div>
		</div>
		<div style="flex: 1;">
			    <div style="height: 200px;">
					<el-button style="margin: 20px 0 0 30px;" type="primary" v-print="'#printTest'"  @click="addPrintNum()">{{$t('other.a342')}}</el-button>
					<!-- <el-button id="pprint" style="margin: 20px 0 0 30px;" type="primary" @click="ttp()">{{$t('other.a342')}}</el-button> -->
					<!-- <button @click="start_print">开始打印</button> v-print="'#printTest'" -->
				</div>
				<div style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
					<div style="font-size: 14px;padding-left: 10px;">{{$t('other.a346')}}</div>
					 <el-select style="margin-left: 15px;" size="mini" v-model="value" :placeholder="$t('other.a50')" @change="chosePage()">
						<el-option
						  v-for="item in options"
						  :key="item.value"
						  :label="item.label"
						  :value="item.value">
						</el-option>
					 </el-select>
				</div>
				<div v-show="value == '10' "  style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
					<div style="font-size: 14px;padding-left: 10px;">{{$t('other.a347')}}</div>
					<el-input style="width:120px;padding-left:15px" @keyup.native="oop" size="mini" v-model="widthValue" :placeholder="$t('other.a319')"></el-input>
					<label style="font-size:14px;padding-left:10px">{{$t('other.a349')}}</label>
				</div>
				<div v-show="value == '10' "  style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
					<div style="font-size: 14px;padding-left: 10px;">{{$t('other.a348')}}</div>
					<el-input style="width:120px;padding-left:15px" @keyup.native="oop1" size="mini" v-model="heightValue" :placeholder="$t('other.a319')"></el-input>
					<label style="font-size:14px;padding-left:10px">{{$t('other.a349')}}</label>
				</div>
			
		</div>
		
	</div>
	
</template>
<script>
import QRCode from 'qrcodejs2'
import jrQrcode from "jr-qrcode"
import JsBarcode from 'jsbarcode'
import utils from '../../../../utils/utils'
import printApi from '../../../../api/moudles/print.js'
import api from '../../../../api/api'
import newOrderApi from '../../../../api/moudles/newOrders'
import orderApi from '../../../../api/moudles/order'
import loading from '../../../../components/loading_2.vue'




	import {
		mapState,
		mapMutations ,
	     mapActions,
	} from 'vuex'

	import pdf from 'vue-pdf'

	export default {
	    data() {
	      return {
			  useraddress:'',
			userId:JSON.parse(localStorage.getItem('userInfo')).userId,
	        th_printdata:[],
			barcodeValue:123,
			ivn:'<p>123</p>',
			orderList:[],
			storeItemList:[],
			tip:this.$t('other.a500'),
			arr:[],
			options: [{
			          value: 1,
			          label: this.$t('other.a493')
			        }, {
			          value: 2,
			          label: this.$t('other.a494')
			        }, {
			          value: 3,
			          label: this.$t("other.a350")
			        }, {
			          value: 4,
			          label: this.$t("other.a351")
			        }],
					value:3,
					sliderStyle:{
						'width':'98mm',
						'height':'130mm',
						'background-color': '#fff',
						'margin-top':'10px',
						'position':'relative',
						"page-break-after":"always"
					},

					sliderStyleCopy:{
						'width':'98mm',
						'min-height':'130mm',
						'background-color': '#fff',
						'margin-top':'10px',
						'position':'relative',
						"page-break-after":"always"
					},
					widthValue:'100mm',
					heightValue:'150mm',
					checked:false,
					options: [{
					          value: '10',
					          label: this.$t("other.a350")
					        }, {
					         value: '20',
					         label: 'A4'
					        }, {
					          value: '30',
					          label: 'A5'
					        }, ],
					        value: '10',
							loadingList:[],
							loadedList:[],
							currentPage2: 1,
							pageSize:10,
							chooseList:null,
							generateOrderId:[]
					
		  }
	    },
		components:{
			loading,
			pdf

			
		},
		computed:{
			...mapState({
				picklist: state => state.order.picklist,
				seller: state => state.login.userInfo.userId,
				buttonMapList: state => state.print.buttonMapList,
				toPrintOrders: state => state.common.toPrintOrders,
			}),

			
			
			listCopy(){
				if(this.checked){
					let list=this.th_printdata
					let list2=list.slice((this.currentPage2 - 1) * this.pageSize, (this.currentPage2) * this.pageSize)
					console.log(list2)
				
					this.chooseList=list2
					return list2
				}else{
					return this.th_printdata
				}
			},
		
			
		},
		watch:{
			listCopy(){
				console.log(this.listCopy)
			},
			storeItemList(){
				let list=this.orderList
				let storeItem=this.storeItemList
		
				list.forEach(p => {
					p.items.forEach(i => {
						i.storeItem=storeItem[i.itemId+'_' +i.variationId]
					})
				})
				console.log('list',list)
				this.th_printdata=list
				
			},
		},
		created(){
			this.getOrdersByOrderId()
			this.getHtmlByOrderId()
		},
		mounted(){
			
		},
		methods:{
			...mapActions('order', [
				'getUnprocessOrder',//获取所有商店待处理订单
				'auditOrder',
				'getPrintOrder', //打印订单
				'getOrdersBytrickNo'
				
			]),
			...mapActions('print', [
				'addPrintNum',
			
			]),
			...mapMutations('print', [
				'SET_ITEMS',
				'SET_HAS_PRINTED',
				'SET_TTP',
				'SET_HAS_PRINTED_READY',
				'INIT_DATA',
				'FAST_PRINT',
				'UPDATA_PAGE',
				'SENT_PPT'
			]),

			getHtmlByOrderId(){
				let list=JSON.parse(localStorage.getItem('unprocessedOrderIds'))
				let Base64 = require('js-base64').Base64
				newOrderApi 
				.getOrderBillUrl(list)
				.then(res => {
				if(res.code === 200 ){
				console.log('面单地址',res.data)
				res.data.forEach(p => {
					let bba=JSON.parse(p.url).data.document.file
					console.log(bba)
				})
				}else{
				this.$message.warning(res.msg)
				}
				})
			},
			getUserAddress(){
				let params={
					cacheKey:this.userId+'_'+'Shipper_Address',
					userId:this.userId
				}
				api
				.getUserCache(params)
				.then(res => {
				if(res.code === 200 ){
					console.log(res)
					if(res.data){
						this.useraddress = JSON.parse(res.data.cacheData)
					}else{
						this.$message.warning(this.$t('other.a937'))
					}
				
				}else{
				this.$message.warning(res.msg)
				}
				})
			},

			getOrdersByOrderId(){
				let list=JSON.parse(localStorage.getItem('unprocessedOrderIds'))
				
				newOrderApi
				.getOrderPDF(list)
				.then(res => {
					if(res.code === 200) {
						console.log('获取到订单数据',res.data)
						res.data.forEach((p ,index) => {
							p.No=index
						})
						this.th_printdata=res.data
						this.init()
						console.log('originData',res.data)
						
						
					}
				})
			},
			init(){
				
				this.arr=JSON.parse(JSON.stringify(this.th_printdata))
				console.log('arr',this.arr)
				
				this.arr.forEach(p => {
				
				  let list3=[]
					p.itemsCopy=[]
					if(p.items.length > 0){
						p.items.forEach(k => {
							if(!k.storeItem || !k.storeItem.children  ||  k.storeItem.component){//判断items里的每个item是不是套餐，不是才push
								
								k.cusCode=k.storeItem ? k.storeItem.cusCode : '-'
								k.skuName=k.storeItem ? k.storeItem.skuName : '-'
								k.address=k.storeItem ? k.storeItem.address : '-'
								k.purchaseNum=k.variationQuantityPurchased
								k.rate=1
								p.itemsCopy.push([k])
								k.isComponent=true
						    }
							
							if(k.storeItem && k.storeItem.additions !== null){
								if(k.storeItem.additions.length> 0){
									let arr2=[]
									k.storeItem.additions.forEach(p => {
										p.purchaseNum=k.variationQuantityPurchased
										arr2.push(p)
									})

									list3.push(arr2)
								}
							}

						
							if(k.storeItem && k.storeItem !== null && k.storeItem.children){
								if(k.storeItem.children.length>0 && !k.storeItem.component){
									k.isComponent=false
									let list2=[]
									k.storeItem.children.forEach(i => {
										i.purchaseNum=k.variationQuantityPurchased
									
										list2.push(i)
									})
									list3.push(list2)
									
								}
							}
						})
					}

					if(list3.length){
						list3.forEach(i => {
							p.itemsCopy.push(i)
						})
					}
						
				})

				
				
				console.log('arr2',this.arr)
				
				this.th_printdata.forEach(p =>{
					p.genre='order'
				})
				
				
				this.arr.forEach(p => {
					p.genre='picklist'
				})
			
				this.th_printdata=[...this.th_printdata,...this.arr]
				this.th_printdata.sort((a,b) => {return a.No-b.No })
				
				console.log('852',this.th_printdata)
				
				
				
				
			},
		

			addPrintNum(){
				let list=JSON.parse(localStorage.getItem('unprocessedOrderIds'))
				newOrderApi
				.addPrintNum(list)
				.then(res => {
					if(res.code === 200){
						console.log('增加了打印次数！')
					}else{
						console.log('增加了打印次数！',res.msg)
					}
				})


				let obj={
					userId:this.userId,
					orderIds:list.join(),
					createTime:null,
					printType:'3',
				}

				this.insterPrintRecode(obj)
				
			},

			insterPrintRecode(obj){
				newOrderApi
				.insertPrintHistory(obj)
				.then(res => {
				if(res.code === 200 ){
				console.log('desc',res.data)
				}else{
				this.$message.warning(res.msg)
				}
				})
			},
			
			 start_print(){
			        this.$print(this.$refs.dfbfjj);//$refs的值要和html里的ref一致
			    },
			
			
			handleSizeChange(val) {
			        console.log(`每页 ${val} 条`);
					this.pageSize=parseInt(`${val}`)
			      },
			handleCurrentChange(val) {
				
				this.currentPage2=parseInt(`${val}`)
				console.log(this.chooseList);
				this.getPirntPdf()
				
				
			},
			
			
			//获取最新的面单
			getNewOrderList(arr){
				printApi
				.getNewOrders(arr)
				.then(res => {
					if(res.code === 200){
						console.log('获取到最新的订单',res.data)
						let newData=res.data
						newData.forEach(p => {
							this.th_printdata.forEach(i => {
								if(i.orderId == p.orderId && p.image !== null && p.ready == true){
									i.image=p.image
								}
							})
							this.generateOrderId.forEach((k,index) => {
								if(k === p.orderId && p.ready == true && p.image!== null){
									this.generateOrderId.splice(index,1)
								}
							})
						})
						
						if(this.generateOrderId.length> 0){
							this.getNewOrderList(this.generateOrderId)
						}
					}
				})
			},
			
			chosePage(){
				console.log(this.value)
				if(this.value == '20'){
					this.sliderStyle.width='210mm'
					this.sliderStyle.height='297mm'
				}else if(this.value == '30'){
					this.sliderStyle.width='148mm'
					this.sliderStyle.height='210mm'
				}else if(this.value == '10'){
					this.sliderStyle.width='100mm'
					this.sliderStyle.height='150mm'
					this.widthValue='100'
					this.heightValue='150'
				}
			},

			refreshOrder(item){
				console.log(item)
				printApi
				.startReadyOrders({
					userId:this.userId,
					type:0,
					orderId:item.orderId
				})
				.then(res => {
					if(res.code === 200) {
						console.log('重新加载面单',res.msg)
					}else{
						this.$message.warning(res.msg)
					}
				})
			},
			
			oop1(){
				
				this.sliderStyle.height=this.heightValue + 'mm'
			},
			oop(){
				console.log(this.widthValue)
				this.sliderStyle.width=this.widthValue + 'mm'
			},
			//深拷贝数组
			copy (obj) {
			        var newobj = []
			        if(typeof obj !== 'object'){
			            return;
			        }
			        for(var i in obj){
			           newobj[i] = typeof obj[i] === 'object' ? this.copy(obj[i]) : obj[i];
			        }
			        return newobj
			},
		     ttp(){
				var headstr = "<html><head><title></title></head><body>";
				var footstr = "</body>";
				var newstr = this.$refs.menuItem.innerHTML;
				const oldstr = document.body.innerHTML;
				document.body.innerHTML = headstr+newstr+footstr;
				setTimeout(() => {
					document.body.innerHTML = oldstr;
				},1000)
				window.print(); 
				return false
			
			
			},
		
			
			
			getTiem(time) {
				
				if(typeof(time) ==Array ){
					return 'pending update'
				}else{
					
					return utils.renderTime(time)
				}
				
				
			},
		}
	  }
</script>

<style>
.order_title{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 10px;
}
.ord_ba_la{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding:0px 10px;
}
.ord_sold_la{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding:0px 10px;
	font-size: 12px;
	font-weight: bold;
}
.ord_addre_la{
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	padding:0px 10px;
	font-size: 12px;
	font-weight: bold;
}
.ord_code_la{
	padding: 0px 10px;
}
.ord_track_la{
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding: 0px 10px;
	font-size: 13px;
	font-weight: bold;
}
.ord_val_la{
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 12px;
	font-weight: bold;
	padding: 0px 10px;
}
.ord_pritime_la{
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding: 10px;
	font-size: 14px;
}
.ord_tol_la{
	background: #fff;
	position: absolute;
	bottom: 0;
	
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding:0px;
}
.pro_foter{
		width: 90px;
		height: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
		border: 1px solid #000;
		
    }
    .pro_fot_one{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50%;
        /* border-right: 1px solid #000; */
    }
    .pro_fot_two{
        display: flex;
        align-items: center;
        justify-content: center;
		width: 50%;
		font-weight: bold;
    }
.ord_val_one{
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.ord_cod_la{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0px 10px;
	font-size: 13px;
	font-weight: bold;
}
.ord_ba_one{
	width: 60%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: column;
	
}
.order_tit_one{
	margin: 5px 0px;
	font-size: 12px;
	font-weight: bold;
	width: 80%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
	flex-direction: column;
    /* flex-direction: column; */
    /* border: 1px solid #000; */
}
.ord_top{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    
}
.ord_fo_txt{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    word-break:break-all
}
.ord_fo_tit{
    display: flex;
    align-items: center;
    justify-content: flex-start;
	word-break:break-all
}
.ord_four{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between\;
}
.ord_left_one{
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	flex-direction: column;
}
.order_tit_two{
	width: 20%;
	margin: 5px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
}
.ord_left{
   
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    width: 50%;
    border-right: 1px solid #000;
}
.ord_right{
    
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    width: 50%;
    /* border-right: 1px solid #000; */
}


	
	.newpage{
		width: 100%;
		background: #fff;
		z-index: 99999;
		display: flex;
		position: absolute;
		/* display: flex;
		flex-direction: column;
		justify-content: center; */
	
	}

	.newpage .item_order_desc{
		padding-right:3px;

	}
	
	
	@page
	{ 
		margin: 0mm 0mm 0mm 0mm;  
	}
	@page:first
	{ 
		margin-top: -5mm ;  
	}
	
	
	.pic-box{
	  width: 100%;
	  image-rendering:-moz-crisp-edges;
	  image-rendering:-o-crisp-edges;
	  image-rendering:-webkit-optimize-contrast;
	  image-rendering: crisp-edges;
	  -ms-interpolation-mode:nearest-neighbor;
	 }
	
	.newpage .pick-list-wrpper{
		width: 100%;
		
		font-size: 12px;
		position: relative;
	}
	
	.orderpage-btn{
		width: 800px;
		margin: 0 auto;
		display: flex;
		justify-content: flex-end;
		padding: 10px 0;
	}
	
	.newpage .print-area{
		
		
		margin-bottom: 200px;
		
		
	}
	.desc-info{
		width: 798px;
		
		border: 2px #000000 solid;
	}

	.newpage .loading-box{
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		margin: auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	
	.newpage .orderpage-poo-box{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding-bottom: 5px;
		border-bottom: 2px #000000 dashed
	}

	.newpage .desc_failed{
		padding: 8px 0;
		text-align: center;
		color: rgb(152 148 148)
	}
	
	.newpage  .orderpage-poo{
		min-width: 265px;
		height: 40px;
		border: 2px solid #000000;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		margin: 5px 10px;
	}
	
	.newpage  .receipt-item{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding:5px 10px;
	}
	
	.newpage  .receipt-item .area {
		display: inline-block;
		width: 50%;
		font-size: 18px;
	}
	
	.newpage  .desc-info-left-text{
		font-size: 18px;
		font-weight: bold;
		padding-right: 30px;
	}
	
	.newpage  .desc-info-footer{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 5px 10px;
	}
	
	.newpage  .tto{
		display: inline-block;
		width: 200px;
		text-align: center;
		box-sizing: border-box;
		padding: 5px;
	}
	.newpage  .tto01{
		display: inline-block;
		width: 100px;
	}
	.newpage  .cco{
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		border-bottom: 1px #000000 solid;
		box-sizing: border-box;
		padding: 0 10px;
	}
	
	.newpage  .city-tap{
		display: inline-block;
		padding: 5px;
		border: 2px solid #000000;
		margin: 5px 0;
		padding: 5px 15px;
		font-size: 18px;
	}
	
	.newpage  .city-tap01{
		display: inline-block;
		padding: 5px;
		border: 2px solid #000000;
		margin: 5px 5px;
		font-size: 18px;
		padding: 5px 15px;
	}


	
	
	
	
	.newpage  .desc{
		/* position: absolute;
		top: 40%;
		left: 25%;
		bottom: 0;
		right: 0;
		margin: auto; */
		font-size: 18px;
		font-weight: bold;
		color: red;
		opacity: 0.3;
		
		
		
	}
	.newpage  .oook{
		margin-bottom: 20px;
		
	}
	

	
/* 	.pp-wrapper{
		position: absolute;
		left: 0;
		right: 0;
		margin: 0 auto;
	}	 */
	
	.newpage  .printTest-box{
		width: 80%;
		overflow-y: auto;
		height: 100vh;
		background-color: #000;
		position: relative;
	
	}
	
	.newpage  .page-box{
		/* width: 800px;
		height: 670px; */
		overflow: hidden;
		background-color: #fff;
		/* position: absolute;
		left: 0;
		right: 0;
		margin: 0 auto; */
		
	}
	
	.newpage .el-icon-loading:before {
	    content: "\E6CF";
	    font-size: 60px;
	}

	.newpage .loading_style{
		background-color: #454040;
		position: absolute !important;
		width: 100%;
		height: 100vh;
		left: 0;
		
	}


	
	.el-popper{
		z-index: 999999!important;
	}
	
	.img-wrapper{
	  width: 1100px;
	  height: 1188px;
	  margin: -369.5px -354.5px;
	  transform: scale(0.36);
	}
	
	.fenpi{
		display: flex;
		align-items: center;
		width: 100%;
		height: 50px;
		line-height: 50px;
		background-color: #fff;
		position: fixed;
		bottom: 0;
		z-index: 999999;
		font-size: 14px;
		padding-left: 15px;
	}
	
	.fenpi-item{
		margin-right: 10px;
	}
	
	
	
</style>
